import React from 'react';

// A simple Instagram Icon SVG to use in the button
const InstagramIcon = () => (
  <svg 
    width="20" 
    height="20" 
    viewBox="0 0 24 24" 
    fill="none" 
    xmlns="http://www.w3.org/2000/svg"
    style={{ marginRight: '8px', verticalAlign: 'middle' }}
    stroke="currentColor"
    strokeWidth="2"
  >
    <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
    <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
    <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
  </svg>
);


const FollowUs = () => {
  return (
    // We reuse the 'newsletter-section' class to keep the same background and padding
    <section className="newsletter-section">
      <div className="newsletter-inner">
        
        {/* The new title */}
        <h2 className="newsletter-title">Follow us on Instagram</h2>
        
        {/* The new subtitle */}
        <p className="newsletter-subtitle">
          See our latest collections, behind-the-scenes, and more.
        </p>

        {/* This is the new "button". 
          It's an <a> tag styled to look just like your old subscribe button.
        */}
        <a
          href="https://www.instagram.com/chawal.taaka/" // <-- Your Instagram link
          target="_blank"
          rel="noopener noreferrer"
          className="newsletter-btn" // We reuse the 'newsletter-btn' style
          style={{ textDecoration: 'none', display: 'inline-block' }} // Added inline styles for <a> tag
        >
          <InstagramIcon />
          Follow @chawal.taaka
        </a>

      </div>
    </section>
  );
};

export default FollowUs;

